import SharedSortableLists from "./SharedSortableLists";
import CreativeDirectorPublicationJobsIndex from "./CreativeDirectorPublicationJobsIndex";

class CreativeDirectorSortablePublicationJobsList extends SharedSortableLists {
  reactTableComponent() {
    return CreativeDirectorPublicationJobsIndex;
  }

  defaultSortKey() {
    return "due";
  }

  sortData() {
    switch (this.sortKey) {
      case "due":
        return this.sortBy({ attr: "due_at_raw" });
      case "deadline":
        return this.sortMulti([
          { attr: "deadline" },
          { attr: "due_at_raw", reverseNever: true },
          { attr: "index" },
        ]);
      case "publication":
        return this.sortMulti([
          { attr: "publication" },
          { attr: "due_at_raw", reverseNever: true },
          { attr: "index" },
        ]);
      case "territory":
        return this.sortMulti([
          { attr: "territory" },
          { attr: "due_at_raw", reverseNever: true },
          { attr: "index" },
        ]);
      case "designer":
        return this.sortMulti([
          { attr: "designer_initials" },
          { attr: "due_at_raw", reverseNever: true },
          { attr: "index" },
        ]);
      default:
        return this.data;
    }
  }
}

export default CreativeDirectorSortablePublicationJobsList;
